import client from './client';

/**
 * 일자별 통계
 */
export const dailyStatistics = (param) => client.get(`/api/report/day`, param);

/**
 * 일자별 통계내 pre 그래프  (매체분포도)
 */
export const pieGraphMedia = (param) =>
  client.get(`/api/report/day/pieGraph`, {
    params: param,
  });

/**
 * 일자별 통계 웹 / 모바일 상세
 */
export const dailyStatisticsDetail = (param) =>
  client.get(`/api/report/day/sub`, param);

/**
 * 일자별 통계 - 구좌별통계 그래프
 */
export const dailyParGraph = (param) =>
  client.get(`/api/report/day/graph`, {
    params: param,
  });

/**
 * 일자별 통계 - 일자별통계 내 상위매체 그래프 데이터
 */
export const dailyTopMediaGraph = (param) =>
  client.get(`/api/report/day/topMedia/graph`, {
    params: param,
  });

/**
 * 일자별 통계 - 일자별통계 내 상위카테고리 그래프 데이터
 */
export const dailyTopCategoryGraph = (param) =>
  client.get(`/api/report/day/topCategory/graph`, {
    params: param,
  });

/**
 * 일자별 통계 - 일자별통계 카테고리통계 내 특정카테고리 그래프 데이터
 */
export const dailyCertCategoryGraph = (param) =>
  client.get(`/api/report/day/category/certGraph`, {
    params: param,
  });

/**
 * 일자별 통계 - 6개월 분석표
 */
export const longTimeGraph = (param) =>
  client.get(`/api/report/day/longTimeGraph`, {
    params: param,
  });

/**
 * 일자별 통계 - 구좌별 타게팅분포
 */
export const dailyTargeting = (param) =>
  client.get(`/api/report/day/targeting`, param);

/**
 * 일자별 통계 - 구좌별 타게팅분포
 */
export const dailyArticle = (param) =>
  client.get(`/api/report/day/article`, param);

/**
 * 일자별 통계 - 구좌별 타게팅분포 상세
 */
export const dailyArticleDetail = (param) =>
  client.get(`/api/report/day/article/sub`, param);

/**
 * 일자별 통계 - 미노출통계
 */
export const dailyNoPar = (param) => client.get(`/api/report/day/noPar`, param);

/**
 * 일자별 통계 - 미노출통계 그래프
 */
export const dailyNoParGraph = (param) =>
  client.get(`/api/report/day/noPar/graph`, {
    params: param,
  });

/**
 * 일자별 통계 - 미노출통계 그래프
 */
export const dailyNoRoasGraph = (param) =>
  client.get(`/api/report/day/roas/graph`, {
    params: param,
  });

/**
 * 시간대별 통계 그래프
 */
export const timeGraph = (param) =>
  client.get(`/api/report/time/graph`, { params: param });

/**
 * 시간대별 소진
 */
export const timeAmtStatistics = (param) =>
  client.get(`/api/report/time`, param);

/**
 * 시간대별 소진 상세
 */
export const timeAmtSubStatistics = (param) =>
  client.get(`/api/report/time/sub`, param);

/**
 * 시간대별 소진 상세
 */
export const timeAmtDetailStatistics = (param) =>
  client.get(`/api/report/time/daily`, param);

/**
 * 시간대별 소진 통계 그래프
 */
export const timeAmtGraph = (param) =>
  client.get(`/api/report/time/amt/graph`, { params: param });

/**
 * 시간대별 구좌별 누적소진
 */
export const timeLimitAmtStatistics = (param) =>
  client.get(`/api/report/time/limitamt`, param);

/**
 * 월별 통계
 */
export const monthStatistics = (param) =>
  client.get(`/api/report/month`, param);

/**
 * 월별 통계 그래프
 */
export const monthGraph = (param) =>
  client.get(`/api/report/month/graph`, { params: param });

/**
 * 월별 통계 전월대비 데이터
 */
export const monthCompare = (param) =>
  client.get(`/api/report/month/compare`, param);

/**
 * 월별 통계 상세 데이터
 */
export const monthsub = (param) => client.get(`/api/report/month/sub`, param);

/**
 * 미소진 통계
 */
export const unpaidStatistics = (param) =>
  client.get(`/api/report/day/unpaid`, param);

/**
 * 총 노출 통계
 */
export const dailyAllParTotal = (param) =>
  client.get(`/api/report/day/total`, param);

/**
 * 총 노출 통계 - 그래프
 */
export const dailyAllParTotalGraph = (param) =>
  client.get(`/api/report/day/total/graph`, { params: param });

/**
 * 캠페인 통계
 */
export const dailyCampaign = (param) =>
  client.get(`/api/report/day/campaign`, param);

/**
 * 캠페인 통계 - 그래프
 */
export const dailyCampaignGraph = (param) =>
  client.get(`/api/report/day/campaign/graph`, { params: param });

/**
 * ROAS - 그래프
 */
export const dailyRoasGraph = (param) =>
  client.get(`/api/report/day/roas/graph`, { params: param });

/**
 * 카테고리 통계
 */
export const dailyCategoryRoas = (param) =>
  client.get(`/api/report/day/category`, param);

/**
 * 카테고리 통계 - 그래프
 */
export const dailyCategoryRoasGraph = (param) =>
  client.get(`/api/report/day/category/graph`, { params: param });

/**
 * cw 통계
 */
export const cwList = (params) =>
  client.get(`/api/report/day/cwAnalysis`, params);

/**
 * cw 통계 - 그래프
 */
export const cwGraph = (params) =>
  client.get(`/api/report/day/cwAnalysis/graph`, { params: params });

/**
 * 앱트래커
 */
export const trackerList = (params) =>
  client.get(`/api/report/tracker`, params);

/**
 * 애드블록 통계 데이터
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export const adblock = (params) => client.get(`/api/report/adblock`, params);

/**
 * 애드블록 통계 일자별 그래프 데이터
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export const adblockDayGraph = (params) =>
  client.get(`/api/report/adblock/day/graph`, { params: params });

/**
 * 애드블록 통계 그래프 데이터
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export const adblockGraph = (params) =>
  client.get(`/api/report/adblock/graph`, { params: params });
